<template>
  <div class="container side_bar">
    <NovoLancamento class="w-100" />
    
    <b-button id="addItens"
              class="mt-3 p-2 pl-3 pr-3 w-100"              
              :disabled="caixa.ultimoCaixa"
              @click="mudarRota">
      Fechamento de caixa 
    </b-button>
    <SangriaCaixaVue class="w-100" />
    <div v-if="!caixa.ultimoCaixa"
         class="saldo">
      <span>Saldo</span>
      <input id="custa_valor"
             v-money="money"
             class="w-100"
             :value="cxSaldo != null ? cxSaldo.pedidos.saldoTotal : 0"
             disabled
             name="custa_ipesp"
             size="sm"
             trim>
    </div>
  </div>
</template>

<script>
  // Importes
  import NovoLancamento from './NovoLancamento.vue'
  import SangriaCaixaVue from '../SangriaCaixa/SangriaCaixa.vue'
  import { VMoney } from 'v-money'


  export default ({
    name: "SidBarPendentes",
    directives: {
      money: VMoney
    },
    components: {
      NovoLancamento,
      SangriaCaixaVue,
    },
    props: {

    },
    data () {
      return {
        dataAtual: '',
        dataAdpter: '',
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },
      }
    },
    computed: {
      cxData () {
        return this.$store.state.frenteCaixa.cxData
      },
      cxSaldo () {
        return this.$store.state.frenteCaixa.saldo
      },
      caixa () {
        return this.$store.state.frenteCaixa.caixa
      }
    },
    methods: {
      mudarRota () {
        this.$router.push('/fechamento-frente-de-caixa')
      }
    }
  })

</script>

<style scoped lang="scss">
  @import "../../../../scss/_utilities/_variables";
  .container {
    border-left: solid $sinoreg-blue;
  }
  .side_bar {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .caixa-title {
    font-weight: bold;
    font-size: 18px;
  }
  .icon-add-new {
    fill: #1c7af5;
    width: 20px;
    height: 20px;
    transition: fill 0.2s;
    margin-right: 10px;
  }
  #addItens:hover .icon-add-new {
    fill: white;
  }
  .saldo {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    font-size: 22px;
    color: #1F613D;
    display: flex;
    align-items: end;
    justify-content: space-between;
  }
  .saldo input {
    text-align: right;
    color: #1F613D;
  }
</style>>
